import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "getApp": "Get App",
      "downloadNow": "Download Now for FREE",
      "learnMore": "Learn More",
      "neverLose": "Never Lose",
      "socialContent": "Social Content",
      "again": "Again!",
      "heroDescription": "Collect, organize, and rediscover your favorite posts, videos, and stories from all social media platforms in one beautiful app.",
      "everythingYouNeed": "Everything You Need to",
      "organize": "Organize",
      "featuresDescription": "Klipiz gives you powerful tools to capture, organize, and rediscover your favorite social media content from 7 platforms",
      "supports": "Supports:",
      "statPlatforms": "Social Platforms",
      "statStorage": "Storage Capacity",
      "statPrivate": "Private & Secure",
      "statAccess": "Available Access",
      "searchContent": "Search content",
      "lovedBy": "Loved by",
      "users": "Users",
      "testimonialsDescription": "See what people are saying about Klipiz",
      "readyToNeverLose": "Ready to Never Lose Content Again?",
      "ctaDescription": "Join thousands of users who have transformed how they save and organize social media content from at least 7 sources.",
      "getSocialCollector": "Get Klipiz for FREE",
      "trial": "✓ Free and premium mode",
      "cancelAnytime": "✓ Cancel anytime",
      "securePayment": "✓ Secure payment",
      "worksWith": "Works with:",
      "loginTitle": "Klipiz Login",
      "socialCollectorConnection": "Klipiz Login",
      "email": "Email",
      "password": "Password",
      "login": "Login",
      "footerDescription": "The ultimate app for organizing your social media content from 7 different sources.",
      "features": "Features",
      "featurePlatform": "7 Sources support",
      "featureSmart": "Smart organization",
      "featureSearch": "Powerful search",
      "featurePrivacy": "Privacy mode",
      "support": "Support",
      "helpCenter": "Help Center",
      "contactSupport": "Contact Support",
      "privacyPolicy": "Privacy Policy",
      "termsOfService": "Terms of Service",
      "download": "Download",
      "googlePlay": "Google Play Store",
      "copyright": "© 2025 Klipiz. All rights reserved.",
      "chakchkouka": "chakchkouka",
      "boulettesVeganes": "vegan balls",
      "framboise": "raspberry",
      "panacota": "panna cotta",
      "featureMulti-PlatformSupport": "7 Platform support",
      "featureMulti-PlatformSupportDesc": "Save content from TikTok, Instagram, X (Twitter), Facebook, Web, YouTube, and Pinterest all in one place",
      "featureSmartOrganization": "Smart organization",
      "featureSmartOrganizationDesc": "Create custom collections and tags to organize your saved content exactly how you want",
      "featurePowerfulSearch": "Powerful search",
      "featurePowerfulSearchDesc": "Find any saved link instantly with full-text search functionality",
      "featurePrivacyMode": "Privacy mode",
      "featurePrivacyModeDesc": "Switch to discreet mode or display only selected thumbnails for complete privacy",
      "featureThemeOptions": "Theme options",
      "featureThemeOptionsDesc": "Choose between light and dark modes to match your preference",
      "featureMulti-DeviceSync": "Multi-device sync",
      "featureMulti-DeviceSyncDesc": "Access your collections seamlessly across all your phones and tablets",
      // Privacy Policy translations
      "privacyTitle": "Privacy Policy – Klipiz",
      "lastUpdated": "Last updated:",
      "lastUpdatedDate": "July 27, 2025",
      "privacyWelcome": "Welcome to Klipiz, an application that allows you to save, organize, and easily find your content from social networks. We attach great importance to the confidentiality of your personal data.",
      "dataCollected": "Data collected",
      "userAccount": "User account: email address, identifier.",
      "savedContent": "Saved content: links, titles, descriptions, categories, tags.",
      "technicalData": "Technical data: device, application version.",
      "subscriptionData": "Subscription data: for Premium users.",
      "noSensitiveData": "No sensitive data is collected (contacts, messages, passwords).",
      "dataUsage": "Data usage",
      "dataUsedFor": "Data is used for:",
      "createAccount": "Creating and managing your user account.",
      "saveLinks": "Saving your links and categories.",
      "improvePerformance": "Improving application performance.",
      "manageSubscriptions": "Managing Premium subscriptions and payments.",
      "dataSharing": "Data sharing",
      "noDataSale": "We do not sell or share your data with unauthorized third parties.",
      "dataSharedWith": "Data may only be shared with:",
      "technicalProviders": "Our technical providers (hosting, analytics), under confidentiality agreement.",
      "legalAuthorities": "Legal authorities, only in case of legal obligation.",
      "security": "Security",
      "securityMeasures": "We use technologies compliant with security standards: encryption, authentication, access monitoring.",
      "yourRights": "Your rights",
      "gdprCompliant": "In accordance with GDPR, you can:",
      "accessData": "Access your data",
      "requestCorrection": "Request their correction or deletion",
      "objectProcessing": "Object to their processing",
      "requestPortability": "Request their portability",
      "exerciseRights": "To exercise your rights:",
      "retentionPeriod": "Retention period",
      "dataRetention": "Data is retained as long as your account is active. In case of account deletion, they are deleted within 30 days.",
      "modifications": "Modifications",
      "policyUpdates": "This policy may be updated. Users will be notified in case of important changes.",
      "contact": "Contact",
      "privacyQuestions": "For any questions regarding privacy:",
      "backToHome": "Back to Home",
      "googlePlayStore": "Google Play Store",
      "featuresPlatforms": "7 platform support",
      "featuresOrganization": "Smart organization",
      "featuresSearch": "Powerful search",
      "featuresPrivacy": "Privacy mode",
      "allRightsReserved": "All rights reserved.",
      "deleteAccountLink": "Delete my account",
      "footerContact": "Contact",
      "navFeatures": "Features",
      "navHow": "How it works",
      "navPlatforms": "Platforms",
      "navTry": "Try it",
      "landingHeroBadge": "Available on Android and iOS",
      "landingHeroTitle1": "Save your links",
      "landingHeroTitle2": "in one tap.",
      "landingHeroSubtitle": "See something you like? Share it to Klipiz and find it whenever you want. TikTok, Instagram, YouTube — it all works.",
      "landingHeroSocialText": "Works with all your apps",
      "landingFeaturesLabel": "Features",
      "landingFeaturesTitle1": "Everything you need,",
      "landingFeaturesTitle2": "nothing you don't.",
      "landingFeaturesDesc": "Klipiz focuses on the essentials: save links fast and find them easily.",
      "landingFeat1Title": "Instant save",
      "landingFeat1Desc": "Share from any app, pick Klipiz, and it's saved in a second.",
      "landingFeat2Title": "Folder organization",
      "landingFeat2Desc": "Sort your links into custom folders and find them in an instant.",
      "landingFeat3Title": "Quick search",
      "landingFeat3Desc": "Find any saved link with smart search.",
      "landingFeat4Title": "Private by default",
      "landingFeat4Desc": "Your links stay private. Nothing is shared without your consent.",
      "landingFeat5Title": "Cloud sync",
      "landingFeat5Desc": "Your links follow you everywhere. Switch phones without losing anything.",
      "landingFeat6Title": "All apps",
      "landingFeat6Desc": "Works with every app that offers a Share button.",
      "landingHowLabel": "How it works",
      "landingHowTitle1": "3 seconds.",
      "landingHowTitle2": "3 steps.",
      "landingHowDesc": "No complicated account, no setup. You share, it's saved.",
      "landingStep1Title": "You find content",
      "landingStep1Desc": "A TikTok, a reel, an article… any link you like.",
      "landingStep2Title": "You tap Share",
      "landingStep2Desc": "Use your app's share button and choose Klipiz from the list.",
      "landingStep3Title": "It's saved",
      "landingStep3Desc": "Your link is stored and sorted automatically. Find it whenever you want.",
      "landingPlatformsLabel": "Platforms",
      "landingPlatformsTitle1": "Works with your",
      "landingPlatformsTitle2": "favorite apps.",
      "landingPlatformsDesc": "Klipiz works with any app that has a Share button.",
      "platformNameX": "X (Twitter)",
      "platformNameReddit": "Reddit",
      "platformNameSpotify": "Spotify",
      "platformNameWhatsApp": "WhatsApp",
      "landingCtaTitle1": "Ready to never",
      "landingCtaTitle2": "lose a link again?",
      "landingCtaDesc": "Download Klipiz for free and start saving.",
      "landingStoreLabel": "Get it on",
      "landingStoreGoogle": "Google Play",
      "landingStoreApple": "App Store",
      "landingFooterPrivacy": "Privacy",
      "landingFooterTerms": "Terms",
      "landingCopyright": "© 2025 Klipiz. All rights reserved.",
      "landingTestimonial1Text": "Finally, an app that keeps all my inspiration organized! No more lost posts or forgotten videos.",
      "landingTestimonial1Name": "Sophie L.",
      "landingTestimonial1Role": "Content creator",
      "landingTestimonial2Text": "Game-changer for my work. I can quickly find any saved content and organize campaigns efficiently.",
      "landingTestimonial2Name": "Emma R.",
      "landingTestimonial2Role": "Digital marketer",
      "landingTestimonial3Text": "The search feature is incredible. I can find any post I saved months ago in seconds!",
      "landingTestimonial3Name": "Maya K.",
      "landingTestimonial3Role": "Social media manager"
    }
  },
  fr: {
    translation: {
      "getApp": "Obtenir l'application",
      "downloadNow": "Télécharger maintenant - GRATUIT",
      "learnMore": "En savoir plus",
      "neverLose": "Ne perdez plus",
      "socialContent": "de contenu social",
      "again": "!",
      "heroDescription": "Collectez, organisez et retrouvez vos posts, vidéos et stories préférés de tous les réseaux sociaux dans une seule application.",
      "everythingYouNeed": "Tout ce dont vous avez besoin pour",
      "organize": "organiser",
      "featuresDescription": "Klipiz vous donne des outils puissants pour capturer, organiser et retrouver vos contenus favoris de 7 plateformes sociales",
      "supports": "Prend en charge :",
      "statPlatforms": "Plateformes sociales",
      "statStorage": "Capacité de stockage",
      "statPrivate": "Privé & Sécurisé",
      "statAccess": "Accès 24/7",
      "searchContent": "Rechercher un contenu",
      "lovedBy": "Adoré par",
      "users": "les utilisateurs",
      "testimonialsDescription": "Découvrez ce que les utilisateurs disent de Klipiz",
      "readyToNeverLose": "Prêt à ne plus jamais perdre de contenu ?",
      "ctaDescription": "Rejoignez des milliers d'utilisateurs qui ont transformé leur façon de sauvegarder et organiser du contenu social.",
      "getSocialCollector": "Obtenir Klipiz - 14,90€/an",
      "trial": "✓ 2 modes : gratuit et premium",
      "cancelAnytime": "✓ Annulable à tout moment",
      "securePayment": "✓ Paiement sécurisé",
      "worksWith": "Fonctionne avec :",
      "loginTitle": "Connexion Klipiz",
      "socialCollectorConnection": "Connexion Klipiz",
      "email": "Email",
      "password": "Mot de passe",
      "login": "Se connecter",
      "footerDescription": "L'application ultime pour organiser vos contenus sociaux de 7 plateformes.",
      "features": "Fonctionnalités",
      "featurePlatform": "Support de 7 plateformes",
      "featureSmart": "Organisation intelligente",
      "featureSearch": "Recherche puissante",
      "featurePrivacy": "Mode privé",
      "support": "Support",
      "helpCenter": "Centre d'aide",
      "contactSupport": "Contacter le support",
      "privacyPolicy": "Politique de confidentialité",
      "termsOfService": "Conditions d'utilisation",
      "download": "Télécharger",
      "googlePlay": "Google Play Store",
      "copyright": "© 2025 Klipiz. Tous droits réservés.",
      "chakchkouka": "chakchkouka",
      "boulettesVeganes": "boulettes veganes",
      "framboise": "framboise",
      "panacota": "panacota",
      "featureMulti-PlatformSupport": "Support de 7 plateformes",
      "featureMulti-PlatformSupportDesc": "Sauvegardez votre contenu de TikTok, Instagram, X (Twitter), Facebook, Web, YouTube, et Pinterest, tout cela en un seul endroit",
      "featureSmartOrganization": "Organisation intelligente",
      "featureSmartOrganizationDesc": "Créez des collections et des tags personnalisés pour organiser vos contenus comme vous le souhaitez",
      "featurePowerfulSearch": "Recherche puissante",
      "featurePowerfulSearchDesc": "Retrouvez n'importe quel lien sauvegardé instantanément grâce à la recherche plein texte",
      "featurePrivacyMode": "Mode privé",
      "featurePrivacyModeDesc": "Passez en mode discret ou affichez uniquement certaines miniatures pour une confidentialité totale",
      "featureThemeOptions": "Options de thème",
      "featureThemeOptionsDesc": "Choisissez entre le mode clair et sombre selon vos préférences",
      "featureMulti-DeviceSync": "Synchronisation multi-appareils",
      "featureMulti-DeviceSyncDesc": "Accédez à vos collections sur tous vos téléphones et tablettes",
      // Traductions Politique de confidentialité
      "privacyTitle": "Politique de confidentialité – Klipiz",
      "lastUpdated": "Dernière mise à jour :",
      "lastUpdatedDate": "27 juillet 2025",
      "privacyWelcome": "Bienvenue sur Klipiz, une application qui vous permet de sauvegarder, organiser et retrouver facilement vos contenus provenant des réseaux sociaux. Nous attachons une grande importance à la confidentialité de vos données personnelles.",
      "dataCollected": "Données collectées",
      "userAccount": "Compte utilisateur : adresse e-mail, identifiant.",
      "savedContent": "Contenus enregistrés : liens, titres, descriptions, catégories, tags.",
      "technicalData": "Données techniques : appareil, version de l'application.",
      "subscriptionData": "Données d'abonnement : pour les utilisateurs Premium.",
      "noSensitiveData": "Aucune donnée sensible n'est collectée (contacts, messages, mots de passe).",
      "dataUsage": "Utilisation des données",
      "dataUsedFor": "Les données sont utilisées pour :",
      "createAccount": "Créer et gérer votre compte utilisateur.",
      "saveLinks": "Sauvegarder vos liens et vos catégories.",
      "improvePerformance": "Améliorer les performances de l'application.",
      "manageSubscriptions": "Gérer les abonnements et les paiements Premium.",
      "dataSharing": "Partage des données",
      "noDataSale": "Nous ne vendons ni ne partageons vos données avec des tiers non autorisés.",
      "dataSharedWith": "Les données peuvent être partagées uniquement avec :",
      "technicalProviders": "Nos prestataires techniques (hébergement, analytics), sous contrat de confidentialité.",
      "legalAuthorities": "Les autorités légales, uniquement en cas d'obligation juridique.",
      "security": "Sécurité",
      "securityMeasures": "Nous utilisons des technologies conformes aux standards de sécurité : chiffrement, authentification, surveillance des accès.",
      "yourRights": "Vos droits",
      "gdprCompliant": "Conformément au RGPD, vous pouvez :",
      "accessData": "Accéder à vos données",
      "requestCorrection": "Demander leur rectification ou suppression",
      "objectProcessing": "Vous opposer à leur traitement",
      "requestPortability": "Demander leur portabilité",
      "exerciseRights": "Pour exercer vos droits :",
      "retentionPeriod": "Durée de conservation",
      "dataRetention": "Les données sont conservées tant que votre compte est actif. En cas de suppression du compte, elles sont supprimées dans un délai de 30 jours.",
      "modifications": "Modifications",
      "policyUpdates": "Cette politique peut être mise à jour. Les utilisateurs seront informés en cas de changement important.",
      "contact": "Contact",
      "privacyQuestions": "Pour toute question relative à la confidentialité :",
      "backToHome": "Retour à l'accueil",
      "googlePlayStore": "Google Play Store",
      "featuresPlatforms": "Prise en charge de 7 plateformes",
      "featuresOrganization": "Organisation intelligente",
      "featuresSearch": "Recherche puissante",
      "featuresPrivacy": "Mode privé",
      "allRightsReserved": "Tous droits réservés.",
      "deleteAccountLink": "Supprimer mon compte",
      "footerContact": "Contact",
      "navFeatures": "Fonctionnalités",
      "navHow": "Comment ça marche",
      "navPlatforms": "Plateformes",
      "navTry": "Essayer",
      "landingHeroBadge": "Disponible sur Android et iOS",
      "landingHeroTitle1": "Sauvegarde tes liens",
      "landingHeroTitle2": "en un clic.",
      "landingHeroSubtitle": "Tu vois un contenu qui te plaît ? Partage-le vers Klipiz et retrouve-le quand tu veux. TikTok, Insta, YouTube… tout y passe.",
      "landingHeroSocialText": "Compatible avec toutes les apps",
      "landingFeaturesLabel": "Fonctionnalités",
      "landingFeaturesTitle1": "Tout ce qu'il faut,",
      "landingFeaturesTitle2": "rien de trop.",
      "landingFeaturesDesc": "Klipiz se concentre sur l'essentiel : sauvegarder tes liens rapidement et les retrouver facilement.",
      "landingFeat1Title": "Sauvegarde instantanée",
      "landingFeat1Desc": "Partage depuis n'importe quelle app, choisis Klipiz, et c'est sauvé en une seconde.",
      "landingFeat2Title": "Organisation par dossiers",
      "landingFeat2Desc": "Classe tes liens dans des dossiers personnalisés pour les retrouver en un instant.",
      "landingFeat3Title": "Recherche rapide",
      "landingFeat3Desc": "Retrouve n'importe quel lien sauvegardé grâce à la recherche intelligente.",
      "landingFeat4Title": "Privé par défaut",
      "landingFeat4Desc": "Tes liens restent privés. Aucun partage sans ton accord.",
      "landingFeat5Title": "Sync cloud",
      "landingFeat5Desc": "Tes liens te suivent partout. Change de téléphone sans rien perdre.",
      "landingFeat6Title": "Toutes les apps",
      "landingFeat6Desc": "Compatible avec toutes les applications qui proposent le bouton Partager.",
      "landingHowLabel": "Comment ça marche",
      "landingHowTitle1": "3 secondes.",
      "landingHowTitle2": "3 étapes.",
      "landingHowDesc": "Pas de compte compliqué, pas de configuration. Tu partages, c'est sauvé.",
      "landingStep1Title": "Tu trouves un contenu",
      "landingStep1Desc": "Une vidéo TikTok, un reel, un article… n'importe quel lien qui te plaît.",
      "landingStep2Title": "Tu cliques Partager",
      "landingStep2Desc": "Utilise le bouton partager de ton app et choisis Klipiz dans la liste.",
      "landingStep3Title": "C'est sauvegardé",
      "landingStep3Desc": "Ton lien est enregistré et classé automatiquement. Tu le retrouves quand tu veux.",
      "landingPlatformsLabel": "Plateformes",
      "landingPlatformsTitle1": "Compatible avec tes",
      "landingPlatformsTitle2": "apps préférées.",
      "landingPlatformsDesc": "Klipiz fonctionne avec toutes les apps qui ont un bouton Partager.",
      "platformNameX": "X (Twitter)",
      "platformNameReddit": "Reddit",
      "platformNameSpotify": "Spotify",
      "platformNameWhatsApp": "WhatsApp",
      "landingCtaTitle1": "Prêt à ne plus jamais",
      "landingCtaTitle2": "perdre un lien ?",
      "landingCtaDesc": "Télécharge Klipiz gratuitement et commence à sauvegarder.",
      "landingStoreLabel": "Télécharger sur",
      "landingStoreGoogle": "Google Play",
      "landingStoreApple": "App Store",
      "landingFooterPrivacy": "Confidentialité",
      "landingFooterTerms": "Conditions",
      "landingCopyright": "© 2025 Klipiz. Tous droits réservés.",
      "landingTestimonial1Text": "Enfin une appli qui garde toute mon inspiration au même endroit ! Fini les posts perdus ou les vidéos oubliées.",
      "landingTestimonial1Name": "Sophie L.",
      "landingTestimonial1Role": "Créatrice de contenu",
      "landingTestimonial2Text": "Un vrai plus pour mon travail. Je retrouve tout ce que j'ai sauvegardé et j'organise mes campagnes efficacement.",
      "landingTestimonial2Name": "Emma R.",
      "landingTestimonial2Role": "Responsable marketing digital",
      "landingTestimonial3Text": "La recherche est incroyable. Je retrouve en quelques secondes un post sauvegardé il y a des mois !",
      "landingTestimonial3Name": "Maya K.",
      "landingTestimonial3Role": "Community manager"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr', // langue par défaut
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 